import { useAccount } from '@/composables/useAccount.js';
import { ca } from '@/lib/channelAttribution.js';
import { getConsent } from '@/lib/trustarc.js';
import { useCurrencyStore } from '@/stores/currency';
import { TRACKING_EMPTY, userLoggedStatus } from '@/tracking/variables';

export function getCommonTracking(nuxtApp) {
  const appConfig = useRuntimeConfig();
  const locale = nuxtApp?.$i18n?.locale;
  const currencyStore = useCurrencyStore();
  const userCurrency = currencyStore.getCurrentCurrency;

  const {
    hasLoggedInUser,
    getRealOrPlaceholderEmail,
  } = useAccount();

  const channelAttributionTrackingData = ca?.getLastChannelAttribution() || null;

  const testingStore = useTestingStore();

  // ### FEATURE TOGGLES
  const geoSpatialSearchEnabled = testingStore.hasEnabledFeature('web_geoSpatialSearch');
  const isAuth0Enabled = testingStore.hasEnabledFeature('web_auth0InStaticweb');

  const searchLeadTime = 1;

  const cmapiPrivacyCookie = useCookie('cmapi_cookie_privacy') || '';
  const noticeBehaviorCookie = useCookie('notice_behavior') || '';
  const noticeGdprPrefsCookie = useCookie('notice_gdpr_prefs') || '';

  const getTrustarcCookieString = () => {
    if (true && document?.cookie) {
      return document.cookie;
    }

    return [
      noticeBehaviorCookie?.value && `notice_behavior=${noticeBehaviorCookie.value}`,
      noticeGdprPrefsCookie?.value && `notice_gdpr_prefs=${noticeGdprPrefsCookie.value}`,
    ].filter(Boolean).join('; ');
  };

  const trustarcCookieString = getTrustarcCookieString();
  const {
    loadAdvertising,
    loadFunctional,
  } = getConsent(trustarcCookieString);

  return {
    getGtmOptions: {
      gtmID: appConfig?.public?.GTM_ID,
      gtmSiteLang: locale?.value,
      gtmSearchCurrency: userCurrency?.code,
      gtmApplicationEnv: appConfig?.public?.RELEASE_ENV,
      gtmHwReleaseVersion: appConfig?.public?.RELEASE_VERSION,
      gtmDomainName: appConfig?.public?.DEFAULT_BASE_URL,
      gtmUserStatus: toValue(hasLoggedInUser) ? userLoggedStatus.loggedIn : userLoggedStatus.loggedOut,
      gtmCustNo: 0,
      gtmUserID: 0,
    },
    getSegmentOptions: {
      site_language: locale?.value,
      cmapi_cookie_privacy: cmapiPrivacyCookie?.value,
      notice_behavior: noticeBehaviorCookie?.value,
      ads_storage: loadAdvertising ? 'granted' : 'denied',
      analytics_storage: loadFunctional ? 'granted' : 'denied',
      release_version: appConfig?.public?.RELEASE_VERSION,
      application_environment: appConfig?.public?.RELEASE_ENV,
      site_currency: userCurrency?.code,
      domain_name: appConfig?.public?.DOMAIN_URL,
      login_status: toValue(hasLoggedInUser) ? userLoggedStatus.loggedIn : userLoggedStatus.loggedOut,
      referrer: channelAttributionTrackingData?.referrer || TRACKING_EMPTY,
      entry_page: channelAttributionTrackingData?.entrypage || TRACKING_EMPTY,
      ref_source: channelAttributionTrackingData?.source || TRACKING_EMPTY,
      affiliate_id: channelAttributionTrackingData?.affiliate || TRACKING_EMPTY,
      gclid: channelAttributionTrackingData?.gclid || TRACKING_EMPTY,
      page_type: channelAttributionTrackingData?.entrypage || 'homepage',
      ga_clientid: TRACKING_EMPTY,
      redesign_version: TRACKING_EMPTY,
      country: TRACKING_EMPTY,
      city: TRACKING_EMPTY,
      continent: TRACKING_EMPTY,
      device_category: TRACKING_EMPTY,
      default_lead_time_in_search: `t+${searchLeadTime}`,
      geospatial_cohort: geoSpatialSearchEnabled ? 'variation' : 'control',
      // Evaluates the email when the property is accessed. This ensures the store is hydrated before accessing state.value.
      get email() {
        return isAuth0Enabled ? getRealOrPlaceholderEmail() : undefined;
      },
    },
  };
}
